import { useSamlBootstrap } from './useSamlBootstrap'
import { useStore } from '@/core'

export const BootstrapGate = ({ children }) => {
  const store = useStore()
  const { booted } = useSamlBootstrap(store)
  return booted ? children : null
}
